import { render, staticRenderFns } from "./DxAi.vue?vue&type=template&id=9c7ca10c&scoped=true&"
import script from "./DxAi.vue?vue&type=script&lang=js&"
export * from "./DxAi.vue?vue&type=script&lang=js&"
import style0 from "./DxAi.vue?vue&type=style&index=0&id=9c7ca10c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7ca10c",
  null
  
)

export default component.exports